import { useFieldHelper } from 'framework/ui/field';
import IconButton from '@mui/material/IconButton';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { useNavigate } from 'react-router-dom';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  useProjectSecurityContext,
  useNewProjectUrl,
  CRITICAL_PERIOD_TYPE,
} from 'domain/shared/newProject';
import { useProjectDataContext } from '../../context/ProjectDataContext';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import { useAsyncValue } from 'framework/utils';

interface RiskFieldProps {
  source: string;
}

const UpdateCriticalPeriodButton = ({ source }: RiskFieldProps) => {
  const { getValue: criticalPeriodId } = useFieldHelper({ source });
  const { getUpdateCriticalPeriodUrl } = useNewProjectUrl();
  const navigate = useNavigate();
  const { data } = useProjectDataContext();
  const { isAccessGranted } = useProjectSecurityContext();

  const canManage = isAccessGranted(ACCESS_INFO_SECTIONS.CRITICAL_PERIOD, ACCESS_INFO_ACTIONS.MANAGE);
  const canPartialManage = isAccessGranted(ACCESS_INFO_SECTIONS.CRITICAL_PERIOD, ACCESS_INFO_ACTIONS.PARTIAL_MANAGE);

  const { getUserAlias } = useAuthenticatedUserService();
  const currentUserAlias = useAsyncValue(() => getUserAlias());
  const criticalPeriod = data?.criticalPeriods?.find(item => item.id === criticalPeriodId());

  const isAuthor = currentUserAlias && criticalPeriod?.createdBy === currentUserAlias;
  const systemType = criticalPeriod?.type === CRITICAL_PERIOD_TYPE.SYSTEM_CREATED;
  const canShowButton = canManage || (canPartialManage && (isAuthor || systemType));

  if (!canShowButton) {
    return null;
  }

  return (
    <IconButton
      onClick={() => navigate(getUpdateCriticalPeriodUrl(data.id, criticalPeriodId()))}
      data-testid="update-button"
    >
      <AppRegistrationIcon color="primary" />
    </IconButton>
  );
};

export default UpdateCriticalPeriodButton;
